<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
  .rules{
    /*width: 1200px;*/
    /*margin: 0 auto;*/
    background: url("../assets/img/bg.png")no-repeat;
    background-position-y:top;
    width: 100%;
    overflow: hidden;
    background-size: 100% 100%;
  }
  .rules .nav{
    background:url('../assets/img/navbg.png')no-repeat;
    width: 1530px;
    height: 110px;
    margin: 0 auto;
    margin-top: 60px;
  }
  .rules .nav img{
    float: left;
    margin-left: 160px;
    margin-top: 35px;
  }
  .rules .nav ul{
    float: left;
    overflow: hidden;
    margin-left: 50px;
  }
  .rules .nav ul li{
    float: left;
    /*margin-right: 40px;*/
    width: 120px;
    text-align: center;
    line-height: 110px;
    color: #ebbfbf;
    font-size: 16px;
    font-weight: 900;
    cursor: pointer;
    position: relative;
  }
  .rules .nav ul li span{
    position: absolute;
    left: 0;
    bottom: -25px;
    text-align: center;
    width: 100%;
    font-weight: 100;
  }
  .rules .nav ul li:hover{
    background:url("../assets/img/hover.png")no-repeat;
    color: #fffefe;
    background-position: 0 11px;
  }
  .rules .nav ul li.on{
    background:url("../assets/img/hover.png")no-repeat;
    color: #fffefe;
    background-position: 0 11px;
  }
  .rules .nav .btn{
    float: right;
    margin-right: 150px;
    width: 185px;
    cursor: pointer;
    margin-top: 30px;
    height: 62px;
    background: url("../assets/img/btn.png")no-repeat;
  }
  .rules .content {
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 195px;
  }
  .rules .content .title{
    margin-top: 100px;
    color: #ffffff;
    font-size: 36px;
    font-weight: 900;
    margin-bottom: 30px;
  }
  .rules .content .title img{
    margin-right: 15px;
  }
  .rules .content .text1{
    padding: 30px;
    background-color: #2a2a2a;
  }
  .rules .content .text1 p{
    font-size: 16px;
    line-height: 40px;
    text-indent: 2em;
    color: #bababa;
  }
</style>
<template>
  <div class="rules">
    <myhead></myhead>
    <nav class="nav">
      <img src="../assets/img/logo.png" alt=""/>
      <ul>
        <li @click="urlFun('/home')"> 首页 <span>Home</span></li>
        <li @click="urlFun('/news')">新闻<span> News</span></li>
        <li class="on" @click="urlFun('/rules')">规则<span> Rule</span></li>
        <li @click="urlFun('/match')">赛程<span>Schedule</span></li>
        <!--<li @click="urlFun('/videoList')">视频<span>Video</span></li>-->
        <li @click="urlFun('/stadium')">场馆<span>Venue</span></li>
        <li @click="urlFun('/live')">直播<span> Live</span></li>
      </ul>
      <div class="btn" @click="urlFun('/signUp')"></div>
    </nav>
    <div class="content">
      <div class="title"><img src="../assets/img/title.png" alt=""/>赛事规则</div>
      <div class="text1">
        <p>比赛游戏：街头霸王V，比赛游戏版本需为当前最新版本，包含角色DLC在内</p>
        <p>游戏设置:对战模式，99秒，2/3回合</p>
        <p>玩家不得在比赛过程中暂定游戏或导致游戏冻结的行为</p>
        <p>主办方可自行决定比赛平台:Windows或PlayStation4</p>
        <p>赛制:双败淘汰赛制，决赛之前采用BO3，决赛采用BO5</p>
        <p>选手应在主办方的指导下，使用规定的角色DLC和服装，且由主办方检查后方可正常开始比赛</p>
        <p>选手ID和昵称需要满足国内法律法规，如出现不适宜ID或昵称，主办方有权更改或模糊该ID和昵称</p>
      </div>
      <div class="title"><img src="../assets/img/title.png" alt=""/>积分体制</div>
      <div class="text1">
        <p>选择顺序：当两个选手都在使用同一个比赛设备时，他们必须对顺序达成一致(palyer1和player2)，如果无法达成协议，主办方有权要求双方 通过锤子剪刀布来决定顺序</p>
        <p>角色选择:有两种选择角色的方法(标准选择，双盲选择)，如果选手的选择角色之前不提及要求选择方法，则统一认定为标准选择，如果选手不能就角色选择方法达成一致，当值裁判将采用双盲方法进行选择</p>
        <p>标准选择:两个玩家随时都可以选择角色，这是一个自由的模式，选手可以随意选择想要选取的角色，一旦任何一方选择了角色，则不允许请求使用双盲选择方法</p>
        <p>双盲选择:任一方选手在选择角色之前，都必须明确要求使用双盲方法来选择角色，player1选手和player2选手需要将所选择的角 色名称隐秘的告知当值裁判，当值裁判最终确认后，双方可以开始选择角色</p>
        <p>比赛中:一旦选择了角色并准备就绪，选手应该立刻开始比赛，一旦比赛结束，以下规则将生效</p>
        <p>当任一选手赢得所需局数时，比赛结束</p>
        <p>一旦选手赢了所需局数，获胜者应该与当值裁判签订比赛结果录入文件</p>
        <p>赢得比赛的选手不能在下一局比赛进行换边，除非败者要求其更换，否则其必须保持一致</p>
        <p>失败的玩家可以选择更换顺序(1P或2P)和更换角色包括V-Trigger</p>
        <p>失败的玩家可以选择任意顺序和角色</p>
        <p>举报违规规则：</p>
        <p>参与比赛的选手需仔细审阅赛事规则，如发现有违规行为请立即向主办方报告</p>
        <p>所有非比赛中的违规行为必须在比赛开始之前向当值裁判报告</p>
        <p>选手在比赛中遇到非游戏相关的违规行为，不得停止正在进行的游戏，私自停止进行中的游戏将会受到处罚，当值裁判会根据当时实际情况进行裁定</p>
        <p>遇到游戏相关违规行为时，选手可停止游戏报告游戏违规。</p>
        <p>选手私自停止游戏报告错误的违规行为，其将被判罚放弃比赛</p>
        <p>违规行为必须在发现后及时进行报告，否则将不再受理</p>
        <p>主办方有权代表选手报告任何违规行为</p>
      </div>
      <div class="title"><img src="../assets/img/title.png" alt=""/>Tournament General Rules</div>
      <div class="text1">
        <p>Tournament Game: The Capcom video game entitled “Street Fighter V: Arcade Edition” and (i) all updates, patches, and stages released as of the date of the Tournament and (ii) character packs released at least seven (7) days prior to the commencement date of the </p>
        <p>Tournament Game Settings: Versus, 99 seconds, 2/3 Rounds</p>
        <p>Players may not use any glitch or bug that prevents the game from being played, including but not limited to bugs causing the game to freeze, reset, remove character from play zone or similar results.</p>
        <p>Platform: The platform for the Capcom Pro Tour shall be the Sony PlayStation 4, provided, however, that in Capcom MV’s sole discretion, a Tournament may be permitted to use the Windows PC platform.</p>
        <p>All Tournament Events: Double Elimination Bracket. 2/3 games until top 8, which is 3/5 games</p>
        <p>Players shall, at the direction of Capcom MV and/or the Tournament Organizer, be prohibited from using certain character costumes during a Tournament and/or Match, which prohibited costumes may be determined by Capcom MV and/or the Tournament Organizer at any time and from time to time in their sole and absolute discretion.</p>
        <p>At the direction of Capcom MV and/or the Tournament Organizer, and subject to Capcom MV and/or the Tournament Organizer’s sole and absolute discretion, a player’s name may be blurred, obscured, and/or changed (particularly in the event that a player’s name is required to appear on any tournament promotional materials and/or on-broadcast assets). A player’s changed name shall be subject to Capcom MV and/or Tournament Organizer’s prior approval, which may be withheld in Capcom MV and/or the Tournament Organizer’s sole and absolute discretion.</p>
      </div>
      <div class="title"><img src="../assets/img/title.png" alt=""/>Tournament Match Play Rules：</div>
      <div class="text1">
        <p>Choosing Sides: When both players are at the game console, they must come to an agreement which side of the machine they will play on (who will sit on 1p and who will sit on 2p). If an agreement cannot be reached, a game of rock-paper-scissors will determine who gets to pick their side.</p>
        <p>Choosing Characters: There are 2 methods for choosing characters: Standard Selection, and Double Blind Selection. If the players do not discuss the method of character selection, it should be understood that the Standard method is being used. If the players cannot come to an agreement on the method of character selection, the judge will apply the double blind method.</p>
        <p>Standard Selection: Both players choose their characters whenever they want. This is a free for all. Players pick who they want and go. Once either player chooses a character, neither is allowed to request that the Double Blind Selection method be used.</p>
        <p>Double Blind Selection: Either player must explicitly ask for the Double Blind Selection method before either player chooses a character. When a player request Double Blind, the player on the left side (1p) decides which character they will choose and whispers his/her selection to the Tournament Organizer. The Tournament Organizer then signals the player on the right (2p) to pick his/her character. Once the player on the right (2p) has finished, the Tournament Organizer makes sure the player on the left (1p) sticks to his/her original choice.</p>
        <p>Playing the Match: Once sides and characters have been chosen, the players should begin the first Game in the Match. The following rules go into effect once a Game ends:</p>
        <p>The Match is over when either player wins the required number of games.</p>
        <p>Once a player has won the required number of games, the Winner of the Match should report the result to the Tournament Organizer.</p>
        <p>The player who won the game does not have the option of switching sides. He/she must stay on the same side if the loser does not want to switch.</p>
        <p>The player who won the last Game is required to keep the same character, however they can change their V-Trigger as long as their new V-Trigger choice is made before their opponent selects their own V-Trigger.</p>
        <p>The player who lost the last Game is allowed to choose whatever they wish.</p>
        <p>Reporting Rule Violations: At some point during the tournament, a player may violate either the tournament rules or the rules for a particular game in a tournament. The following rules apply toward rectifying rule violations.</p>
        <p>It is the responsibility of the players in the Match to detect all Match Rule violations and report them to the Tournament Organizer immediately.</p>
        <p>All non-gameplay rule violations must be reported to the Tournament Organizer before the Game starts (e.g. the Winner switching the characters after winning one Game in a Match).</p>
        <p>Players are not allowed to stop a Game in progress to address a non-gameplay related rule violation. Stopping a Game in progress to report a non-gameplay rule violation will result in the forfeiture the round on the part of the person stopping the game.</p>
        <p>The only time a player is allowed to stop a Game to report a rule violation is when that violation occurs during the middle of the match.</p>
        <p>Stopping a Game in progress to erroneously report a rule violation automatically results in the forfeiture of the round by the player who stopped the game.</p>
        <p>Rule violations must be reported at the time they occur. Otherwise, they will be ignored.</p>
        <p>A Tournament Organizer is allowed to report any rule violations on behalf of a player.</p>
        <p>If a Tournament Organizer stops a game to mis-report a rule violation, the Game is replayed with both players picking the same characters, order, and side. No one is disqualified.</p>
        <p>The only people allowed to stop a Game to report a violation are the Tournament Organizer and the players currently involved in a Match.</p>
        <p>If a player accidentally or intentionally stops his/her game for any other reason, he/she will be forced to forfeit the round. Examples include accidentally pressing the start button on his/her controller to pause the match, unplugging his/her opponent’s joystick, etc. If the game cannot be restarted from the exact point of interruption, the player is forced to forfeit the Game. The Tournament Organizer shall determine whether a player must forfeit the Game, not the players.</p>
        <p>Match interruptions beyond the players’ control (e.g. the game crashes or freezes) will be dealt with directly by the Tournament Organizer. All best attempts will be made to resume the round from where it left off. If that cannot be accomplished, the Game will be replayed with both players picking the same characters and modes.</p>
        <p>Reporting Equipment Failure: Video game hardware has a tendency to break down during tournaments. Buttons or joysticks will occasionally break down in the middle of a match, leaving the player on the broken side at a significant disadvantage. The following rules will be used in the event of a breakdown.</p>
        <p>In the event of an equipment failure, they player has the option to stop the Game in progress to obtain a replacement.</p>
        <p>If a Game is stopped in progress, the reporting player must forfeit the current round.</p>
        <p>New equipment must be immediately available. If replacement equipment cannot be obtained in a timely (within 5 mins of the notification) manner, the player must continue to play on their current equipment or forfeit the Match.</p>
      </div>
      <div class="title"><img src="../assets/img/title.png" alt=""/>大会の一般規則</div>
      <div class="text1">
        <p>大会で使用されるゲーム：CAPCOMのビデオゲーム「ストリートファイターＶ アーケードエディション」及び(1)大会開催日までにリリースされるすべてのアップデート、パッチ及びステージ、(2)大会開催日の7日以上前までにリリースされるキャラクターパック。</p>
        <p>プラットフォーム：CAPCOM Pro TourのプラットフォームはPlayStation 4とする。ただしCAPCOM　MVの独断により、Windows PCをプラットフォームとする大会の開催も許可される。</p>
        <p>ゲーム設定：バーサスモード、99カウント、3ラウンド制</p>
        <p>全大会：ダブルエリミネーション方式トップ8までは2本先取、トップ8は3本先取</p>
        <p>選手はゲームをフリーズ/リセットさせたり、キャラクターをプレイエリア外に出したり、あるいはそれに似た結果を生んでゲームのプレイを妨げるグリッチやバグを利用してはならない。</p>
        <p>選手はCAPCOM MVまたは大会運営者の指示によって、大会または試合中に特定のキャラクターコスチュームの使用を禁じられる場合がある。どのコスチュームが禁止されるかはCAPCOM MVまたは大会運営者が独断により任意のタイミングで決めることができる。</p>
        <p>CAPCOM　MVまたは大会運営者の指示あるいは独断により、選手名にぼかしや覆い、あるいは変更が加えられる場合がある（選手名が大会のプロモーション素材や放送素材に入りこむ場合などは、特にその可能性が高い）。変更後の選手名はCAPCOM　MVまたは大会運営者の事前承認の対象となるが、CAPCOM　MVまたは大会運営者の独断によってそれが差し控えられることもある。</p>

      </div>
      <div class="title"><img src="../assets/img/title.png" alt=""/>大会の対戦ルール</div>
      <div class="text1">
        <p>プレイサイド選択：両選手は、着席の際にマシンのどちら側につくか（誰が1Pで誰が2Pか）について合意しなければならない。合意に達しなかった場合は、ジャンケンで勝った選手が好きなサイドを選べる。</p>
        <p>キャラクター選択：キャラクターの選択方法には次の3つがある：スタンダード、ダブルブラインド、サイド＆キャラクター選択マナー。キャラクター選択方法について選手が協議しない場合、スタンダード方式が使われるものと理解される。キャラクター選択方法について選手が合意に達しない場合、審判はダブルブラインド方式を適用する。</p>
        <p>スタンダード方式：両選手は任意のタイミングで使用キャラクターを選択する。これは自由選択となる。選手は希望するキャラクターを選んでプレイを始める。どちらかの選手がキャラクターの選択を終えると、ダブルブラインド方式の適用を希望することはできなくなる。</p>
        <p>ダブルブラインド方式：選手は、もう一方の選手がキャラクターの選択を終える前に、明確なかたちでダブルブラインド方式を希望しなければならない。選手がダブルブラインド方式を希望した場合、左側の選手（1P）は自分がどのキャラクターを選択するか決め、その選択を審判に耳打ちする。審判は次に右側の選手（2P）にキャラクターを選ぶよう合図する。右側の選手（2P）が選択を終えると、大会運営者が左側の選手（1P）に最初に選んだキャラクターを選択させる。</p>
        <p>サイド＆キャラクター選択マナー：どのサイド（1Pまたは2P）でプレイするかの選択権を得た選手が先にキャラクターを選択する、というマナーがある。これはあくまでもマナーである。選手に何らかの義務を負わせるものではない。</p>
        <p>試合の進行：サイドとキャラクターの選択が終わったら、選手は試合の第1ゲームを開始する。ゲームが終了すると、次のルールが適用される：</p>
        <p>&nbsp;&nbsp;どちらかの選手が規定のゲーム数を取ると、試合は終了する。</p>
        <p>&nbsp;&nbsp;どちらかの選手が規定のゲーム数を取ったら、試合の勝者は審判に結果を報告する。</p>
        <p>&nbsp;&nbsp;ゲームを取った選手にはサイド交替の権利はない。ゲームを落とした選手が移動を望まない場合、サイドの交替はできない。</p>
        <p>&nbsp;&nbsp;先行するゲームを取った選手は同じキャラクターを使い続けなればならないが、Vトリガーの変更はできる。ただし対戦相手がVトリガーを選択する前に先にVトリガーの選択を終えなければならない。</p>
        <p>&nbsp;&nbsp;先行するゲームを落とした選手は自由に次のキャラクター・Vトリガーを選択してよい。</p>
        <p>ルール違反の報告：大会の開催中に、選手が大会ルールまたは大会中の特定ゲームのルールに違反することがある。ルール違反を正すために次の規則が適用される。</p>
        <p>&nbsp;&nbsp;試合に臨む選手は、あらゆる試合のルール違反を発見し、それを即座に大会運営者に報告する責任がある。</p>
        <p>&nbsp;&nbsp;ゲームプレイ外のルール違反はゲームの開始前に大会運営者に報告しなければならない（試合の第1ゲームを取った選手によるキャラクターの変更など）。</p>
        <p>&nbsp;&nbsp;選手はゲーム外のルール違反に対処するために進行中のゲームを中断してはならない。ゲーム外のルール違反に対処するために進行中のゲームを中断すると、ゲームを中断した人物がラウンドを放棄したことになる。</p>
        <p>&nbsp;&nbsp;ルール違反を報告するためにゲームを中断することが許されるのは、かかる違反が試合の最中に発生した場合のみである。</p>
        <p>&nbsp;&nbsp;進行中のゲームを中断してルール違反を指摘したがそれが誤りだった場合は、ゲームを中断した人物がラウンドを放棄したことになる。</p>
        <p>&nbsp;&nbsp;ルール違反はその発生時点で報告されなければならない。そうでないかぎり違反は不問とされる。</p>
        <p>&nbsp;&nbsp;大会運営者は選手の代わりにあらゆるルール違反を報告することができる。</p>
        <p>&nbsp;&nbsp;大会運営者がゲームを中断してルール違反を指摘したがそれが誤りだった場合、両選手は同じキャラクター、順番、サイドを選んでゲームをやり直す。この際、失格者は発生しない。</p>
        <p>&nbsp;&nbsp;違反を指摘するためにゲームを中断できるのは大会運営者と当該試合をプレイ中の選手のみである。</p>
        <p>&nbsp;&nbsp;選手がその他の理由によって偶然あるいは意図的にゲームを中断した場合、そのラウンドは放棄しなければならない。これの例としては、偶然コントローラーのSTARTボタンを押して試合をポーズする、自分あるいは対戦相手のジョイスティックのコードを抜くといった行為などがある。妨害が発生したのとまったく同じ時点からゲームを再開できない場合、その選手は1本を放棄しなければならない。ゲームを放棄しなければならないかどうかを決めるのは、選手ではなく大会運営者である。</p>
        <p>&nbsp;&nbsp;選手にとって不可抗力となる試合妨害（ゲームのクラッシュまたはフリーズなど）は、大会運営者が直接対処する。大会運営者はラウンドを中断時点から再開できるよう最善の努力をする。それが不可能な場合、両選手は同じキャラクターとモードを選んでゲームをやり直す。</p>
        <p>機材の不具合の報告：ビデオゲームのハードウェアは大会中に故障することが少なくない。ボタンやジョイスティックが試合の途中で壊れることもあり、故障した側の選手は非常に不利な立場に追い込まれる。故障が発生した場合は次のルールが適用される。</p>
        <p>&nbsp;&nbsp;機材が故障した場合、選手には進行中のゲームを中断して代替品を入手する選択肢が与えられる。</p>
        <p>&nbsp;&nbsp;進行中のゲームが中断された場合、報告した選手は現行のラウンドを放棄しなければならない。</p>
        <p>&nbsp;&nbsp;新しい機材は即座に用意されなければならない。代替機材が速やかに（通知から5分以内）入手できない場合、選手は現在の機材でプレイを続けるか試合を放棄するかを選択しなければならない。</p>
        <p>&nbsp;&nbsp;代替機材が入手できたら、選手はラウンドの残り時間でボタンの設定や動作の確認をすることができる。代替機材を入手した選手が過度のアドバンテージを得た（これによってEXゲージが大幅にチャージされるなど）と大会運営者が判断した場合、大会運営者は独断により当該選手にゲームの放棄を求めることができる。</p>
        <p>&nbsp;&nbsp;選手はゲーム間であればペナルティを受けることなく機材を交換することができる。この場合交換した選手には、次のゲームが始まる前にボタン類を設定する時間（5分間）が与えられる。</p>


      </div>
    </div>
    <mybottom></mybottom>
  </div>
</template>

<script>
  import myhead from './Head.vue'
  import mybottom from './Bottom.vue'
  export default {
    name: 'rules',
    components: {
      myhead,
      mybottom
    },
    data () {
      return {

      }
    },

    computed:{

    },
    mounted(){

    },
    methods:{
      urlFun(url){
        this.$router.push({path:url})
      },

    },
    filters:{

    }
  }
</script>





// WEBPACK FOOTER //
// src/components/Rules.vue